const colors = {
  "ms-red": {
    900: "#0A0103",
    800: "#4F0110",
    700: "#770119",
    600: "#CC032A",
    500: "#ED0331",
    400: "#FC214C",
    300: "#FD4D70",
    200: "#FD90A6",
    100: "#FEDFE5",
    50: "#FFFAFB",
  },
  "ms-grey": {
    900: "#21191B",
    800: "#3B3435",
    700: "#544D4F",
    600: "#6C6768",
    500: "#848081",
    400: "#B2B2B2",
    300: "#CCCCCC",
    200: "#D9D9D9",
    100: "#E5E5E5",
    50: "#F3F2F2",
  },
  "ms-blue": {
    900: "#051229",
    800: "#0B2352",
    700: "#10357C",
    600: "#1647A5",
    500: "#3470E4",
    400: "#5D8DE9",
    300: "#85A9EF",
    200: "#AEC6F4",
    100: "#D6E2FA",
    50: "#F2F6FF",
  },

  "ms-cyan": {
    500: "#1A9FBD",
    400: "#87C8D5",
    300: "#9FD3DE",
    200: "#B7DEE6",
    100: "#CFE9EE",
    50: "#F2FDFF",
  },
  "ms-green": {
    500: "#6FCD9E",
    400: "#87D5AE",
    300: "#9FDEBE",
    200: "#B7E6CF",
    100: "#CFEEDF",
    50: "#EEFFF7",
  },
  "ms-yellow": {
    500: "#FFDB66",
    400: "#FFE180",
    300: "#FFE799",
    200: "#FFEDB3",
    100: "#FFF3CC",
    50: "#FFF9E5",
  },
  "ms-brick": {
    500: "#CC926E",
    400: "#D4A486",
    300: "#DDB69E",
    200: "#E5C9B7",
    100: "#EEDBCF",
    50: "#F6EDE7",
  },
  "ms-purple": {
    500: "#6E71CC",
    400: "#8689D4",
    300: "#9EA0DD",
    200: "#B7B8E5",
    100: "#CFD0EE",
    50: "#F7F7FF",
  },
  "ms-prepleaf": {
    500: "#4358F6",
    400: "#5D8DE9",
    300: "#85A9EF",
    200: "#AEC6F4",
    100: "#D6E2FA",
    50: "#F2F6FF",
  },
  "ms-primary": "#FFFFFF",
  "ms-error": "#D61E27",
  "ms-warning": "#FF832B",
  "ms-info": "#3470E4",
  "ms-success": "#049402",
  "ms-overlay": "rgb(0, 3, 9, 0.7)",
  "ms-alert": "#FFBF00",
};

export default colors;
